import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { endpoint } from '..';
import Button from '../../../components/Button/Button';
import { useAppDispatch } from '../../../reduxService/hooks';
import RecentProjects from '../../MACRA_1/components/recentProjects/RecentProjects';
import { getActionByProjectType } from '../../actionMap';
import Layout from '../../components/Layout/Layout';
import { cleanProjectInfo } from '../../store/projectInfo/projectInfoSlice';
import './Home.scss';

const Home = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const dispatch = useAppDispatch();
    const { cleanProject } = getActionByProjectType();

    dispatch(cleanProjectInfo());
    dispatch(cleanProject());

    return (
        <Layout>
            <div className='listContainer'>
                <Button
                    className='d-flex justify-content-end mb-3'
                    onClick={() => {
                        navigate(endpoint.projectInfo);
                    }}>
                    {t('home_new_project_button')}
                </Button>
                <RecentProjects />
            </div>
        </Layout>
    );
};

export default Home;
